// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = 'aa992dcc8f3ad2fae7c698ca2737c682f044a225';
export const BUILD_NUMBER = '299';
export const BUILD_TIMESTAMP = '2026-11-05T04:26:55.094Z';
